import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { VehicleModel, VehicleEmissionClasses } from '@wilson/interfaces';

@Injectable({
  providedIn: 'root',
})
export class VehiclesGatewayService {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  public getAllVehicles() {
    return this.httpClient.get<VehicleModel[]>(
      `${this.config.host}/vehicle-models`,
    );
  }

  public getVehicleModel(id: string) {
    return this.httpClient.get<VehicleModel>(
      `${this.config.host}/vehicle-models/${id}`,
    );
  }

  public getVehicleClasses() {
    return this.httpClient.get<VehicleEmissionClasses[]>(
      `${this.config.host}/vehicle-classes/`,
    );
  }
}
